import React from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import {Footer} from "../../../_common/components/Footer/Footer";

export const CompleteDetailsFooter = () => {
  const {currentState} = useSelector(
    (state) => ({currentState: state['completeDetails']}),
    shallowEqual
  );

  const count = currentState.entities ? currentState.entities.length : 0

  return <Footer count={count}/>
};
